export default __webpack_public_path__ + "static/media/users-link-dark.29a573ab.svg";